export default {
  sections: {
    order_summary: 'Resumo do pedido',
  },
  labels: {
    add_items: 'Adicione artigos para começar',
    item_count_one: '{{count}} artigo',
    item_count_other: '{{count}} artigos',
  },
  buttons: {
    return: 'Voltar',
  },
  tip: 'Gorjeta',
};
